export default (returnUrl = null) => {
  window.location.href = `/manage/login?returnurl=${encodeURIComponent(returnUrl || window.location.href)}`;
};
